export const createSnapshotManager = (snapshotManager) => {
    return new SnapshotManagerImpl(snapshotManager);
};
class SnapshotManagerImpl {
    snapshotManager;
    constructor(snapshotManager) {
        this.snapshotManager = snapshotManager;
    }
    create(label) {
        return this.snapshotManager.create(label);
    }
    delete(id) {
        return this.snapshotManager.delete(id);
    }
    list() {
        return this.snapshotManager.list();
    }
}
